import styled from 'styled-components'

export const Buttons = styled.div`
    display: flex;

    .btn {
        display: flex;
        flex-basis: 30px;
        align-items: center;
        justify-content: center;
        border-radius: 3px;
        margin-right: 2px;
        height: 30px;
        width: 30px;
        font-size: 1.2rem;
        backface-visibility: hidden;
        -webkit-font-smoothing: subpixel-antialiased;
        box-shadow: none !important;
        padding: 5px;
        color: ${props => props.theme.admin.editor.text};
        background-color: transparent;

        &.btn-active {
            background-color: #444444;
        }

        svg {
            width: 100%;
        }
    }
`

export const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    display: none;
    min-width: 10rem;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #fff;
    text-align: left;
    list-style: none;
    background-color: #444444;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 3px;
    a {
        color: #fff;
        cursor: pointer;
        &:hover {
            color: #fff;
            background-color: #666;
        }
    }
`
